"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _map = _interopRequireDefault(require("lodash/map"));
var _find = _interopRequireDefault(require("lodash/find"));
var _pick = _interopRequireDefault(require("lodash/fp/pick"));
var _alloyReactDivider = _interopRequireDefault(require("@adsk/alloy-react-divider"));
var _alloyProvider = require("@adsk/alloy-provider");
var _SaveToFiles = _interopRequireDefault(require("../../SaveToFiles"));
var _components = require("../components");
var _QuickReportsPanelContext = _interopRequireDefault(require("../QuickReportsPanelContext"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const FormPanel = _ref => {
  let {
    accountId,
    projectId,
    templates,
    options,
    beforeSubmit,
    onSubmitComplete,
    onValidationError,
    onReportSubmit,
    customSubtext
  } = _ref;
  const {
    reportTitle,
    reportType,
    reportFormat,
    reportComponents,
    isTitleEdited,
    isFormValid,
    saveOptions,
    setSaveOptions,
    setReportTitle,
    setCurrentFormat,
    setCurrentType,
    setIsTitleEdited,
    setCurrentComponents
  } = (0, _react.useContext)(_QuickReportsPanelContext.default);
  const currentTemplate = (0, _find.default)(templates, ['type', reportType]);
  const [disabledRunReport, setDisabledRunReport] = (0, _react.useState)(false);
  const updateReportTitle = value => {
    setReportTitle(value);
    setIsTitleEdited(true);
  };
  const updateReportType = newType => {
    if (newType !== reportType) {
      const template = (0, _find.default)(templates, ['type', newType]);
      setCurrentType(newType);
      if (!template.formats.includes(reportFormat)) {
        setCurrentFormat(template.formats[0]);
      }
      if (!isTitleEdited) {
        setReportTitle(template.title);
      }
    }
  };
  const updateReportFormat = newFormat => {
    if (reportFormat !== newFormat) {
      setCurrentFormat(newFormat);
    }
  };
  (0, _react.useEffect)(() => {
    const selectNewTemplate = newTemplate => {
      updateReportType(newTemplate.type);
      updateReportTitle(newTemplate.title);
    };
    if (templates.length > 0) {
      selectNewTemplate((0, _find.default)(templates, ['type', reportType]) || templates[0]);
    }
    if (currentTemplate?.disabled) {
      const newTemplate = templates.find(template => !template?.disabled);
      if (newTemplate) {
        selectNewTemplate(newTemplate);
      } else {
        setDisabledRunReport(true);
      }
    }
  }, [currentTemplate, templates]);
  const types = (0, _map.default)(templates, (0, _pick.default)(['type', 'title', 'disabled', 'info']));
  const {
    formats,
    components,
    show
  } = currentTemplate || {};
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_components.TitleInput, {
    value: reportTitle,
    onChange: updateReportTitle
  }), /*#__PURE__*/_react.default.createElement(ConfigSelection, null, (show || types.length > 1) && /*#__PURE__*/_react.default.createElement(_components.TypeSelection, {
    value: reportType,
    options: types,
    onChange: updateReportType
  }), (show || formats.length > 1) && /*#__PURE__*/_react.default.createElement(_components.FormatSelection, {
    value: reportFormat,
    options: formats,
    onChange: updateReportFormat
  }), /*#__PURE__*/_react.default.createElement(StyledDivider, null), /*#__PURE__*/_react.default.createElement(_alloyProvider.AlloyProvider, null, /*#__PURE__*/_react.default.createElement(_SaveToFiles.default, {
    isQrp: true,
    projectId: projectId,
    onChange: setSaveOptions,
    folderUrn: saveOptions?.folderUrn,
    saveAsNewFile: saveOptions?.saveAsNewFile,
    checked: saveOptions.checked
  })), /*#__PURE__*/_react.default.createElement(_components.OptionalComponentsSelection, {
    value: reportComponents,
    fields: components,
    onChange: setCurrentComponents,
    customSubtext: customSubtext,
    format: reportFormat,
    reportType: reportType
  })), /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(StyledDivider, null), /*#__PURE__*/_react.default.createElement(_components.CreateReportButton, {
    accountId: accountId,
    projectId: projectId,
    disabled: !isFormValid || disabledRunReport,
    options: options,
    beforeSubmit: beforeSubmit,
    onSubmitComplete: onSubmitComplete,
    onValidationError: onValidationError,
    onReportSubmit: onReportSubmit
  })));
};
FormPanel.defaultProps = {
  beforeSubmit: () => {},
  onSubmitComplete: () => {}
};
FormPanel.propTypes = {
  accountId: _propTypes.default.string,
  projectId: _propTypes.default.string,
  templates: _propTypes.default.array,
  options: _propTypes.default.object,
  setReportTitle: _propTypes.default.func,
  setIsTitleEdited: _propTypes.default.func,
  setCurrentType: _propTypes.default.func,
  setCurrentFormat: _propTypes.default.func,
  beforeSubmit: _propTypes.default.func,
  onSubmitComplete: _propTypes.default.func,
  onValidationError: _propTypes.default.func,
  onReportSubmit: _propTypes.default.func,
  customSubtext: _propTypes.default.string
};
const ConfigSelection = _styledComponents.default.div`
  flex-grow: 1;

  & > div {
    margin-bottom: 16px;
  }
`;
const StyledDivider = (0, _styledComponents.default)(_alloyReactDivider.default)`
  margin: 16px 0;
`;
var _default = exports.default = FormPanel;